import React from 'react';

const PrivacyPolicyPage = () => {
  return (
    <div className="py-16 px-4 bg-gray-50 min-h-screen">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-md p-8 md:p-12">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">Privacy Policy</h1>
        <p className="text-gray-500 text-sm mb-8">Last updated: March 2025</p>

        <div className="space-y-6 text-gray-600">
          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">1. Information We Collect</h2>
            <p>We collect personal information you provide directly to us, such as name, email, phone number, and course preferences when you fill out forms on our website. We also collect usage data automatically through cookies and similar technologies.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">2. How We Use Your Information</h2>
            <p>We use the information to respond to inquiries, process admissions, improve our services, and send updates about our programs. We never sell your personal data to third parties.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">3. Data Security</h2>
            <p>We implement industry-standard security measures to protect your information from unauthorized access or disclosure.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">4. Your Rights</h2>
            <p>You may request access to your data, correction, or deletion by contacting us at <a href="mailto:rdspharmacycollege@gmail.com" className="text-blue-600 hover:underline">rdspharmacycollege@gmail.com</a>.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">5. Cookies</h2>
            <p>We use cookies to enhance your browsing experience. You can disable cookies in your browser settings, but some features may not work properly.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">6. Changes to This Policy</h2>
            <p>We may update this policy from time to time. Changes will be posted on this page with an updated effective date.</p>
          </section>

          <p className="pt-4 text-sm">If you have questions, please contact us at <a href="mailto:rdspharmacycollege@gmail.com" className="text-blue-600 hover:underline">rdspharmacycollege@gmail.com</a>.</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;